import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControl, ValidationErrors } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from 'app/services/login.service';
import { environment } from 'environments/environment';
import { FileInput, FileValidator } from 'ngx-material-file-input';
import { CustomFileValidator } from 'app/shared/validators/custom-file-validator';
import { OtrasGestionesProveedorService } from 'app/services/otras-gestiones-proveedor.service';
import { MisdatosProveedorService } from 'app/services/misdatos-proveedor.service';
import { MensajesHtmlComponent } from 'app/main/private/mensajes-html/mensajes-html.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CargaFacturaService } from 'app/services/carga-factura.service';

@Component({
  selector: 'app-form-consultas-facturacion',
  templateUrl: './form-consultas-facturacion.component.html',
  styleUrls: ['./form-consultas-facturacion.component.scss']
})
export class FormConsultasFacturacionComponent implements OnInit {

  formularioConsultasFacturacion: FormGroup;
  dataBreadcumbPages: Array<any> = [];
  dataBreadcumbTitle: any;
  sessionId: string;
  cuit: string;
  apellidoNombreProveedor: string;

  // Opciones para selects
  meses = [
    { value: '01', text: 'Enero' },
    { value: '02', text: 'Febrero' },
    { value: '03', text: 'Marzo' },
    { value: '04', text: 'Abril' },
    { value: '05', text: 'Mayo' },
    { value: '06', text: 'Junio' },
    { value: '07', text: 'Julio' },
    { value: '08', text: 'Agosto' },
    { value: '09', text: 'Septiembre' },
    { value: '10', text: 'Octubre' },
    { value: '11', text: 'Noviembre' },
    { value: '12', text: 'Diciembre' }
  ];

  anios: number[] = [];
  obrasSociales: any[] = [];
  // obrasSociales = [
  //   { value: 'ASE', text: 'ASE' },
  //   { value: 'OSPM', text: 'OSPM' },
  //   { value: 'OSEN', text: 'OSEN' },
  //   { value: 'SWISS MEDICAL', text: 'SWISS MEDICAL' },
  //   { value: 'OMINT', text: 'OMINT' }
  // ];

  // Validaciones de archivos (copiado de carga-factura)
  readonly maxSize = 3145728; // 3MB
  readonly minSize = 1024; // 1KB

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private _loginService: LoginService,
    private _misDatosProveedorService: MisdatosProveedorService,
    private _otrasGestionesProveedorService: OtrasGestionesProveedorService,
    private _snackBar: MatSnackBar,
    private _cargaFactura: CargaFacturaService,
  ) { 
    this.dataBreadcumbPages = [
      { page: 'Otras gestiones', route: '/proveedores/otras-gestiones' }
    ];
    this.dataBreadcumbTitle = [
      { page: 'Consulta de facturación', route: '/proveedores/otras-gestiones/consulta-facturacion-proveedor' }
    ];

    // Generar años actual y el anterior
    const currentYear = new Date().getFullYear();
 
    this.anios.push(currentYear);
    this.anios.push(currentYear - 1);
  }

  ngOnInit(): void {
    // Verificar autenticación

    this._loginService.getAll().subscribe(resp => {
      if(!resp['isLogged'])
          this.router.navigate(['/login']);

      // Obtener datos de sesión y almacenarlos
      this._loginService.getSessionData().subscribe(response => {
        if (!response['rol'] || response['rol'] != 'PRVGRL')
            this.router.navigate(['/login']);
        
        
        // Almacenar datos de sesión en variables del componente
        this.sessionId = response['session_id'];
        this.cuit = response['cuit'];
        this.apellidoNombreProveedor = response['razon_social'];
        
        this.getObrasSociales(this.sessionId);
        
        

        
      });
    });

    // Inicializar formulario
    this.formularioConsultasFacturacion = this.fb.group({
      beneficiario: ['', [Validators.required, Validators.maxLength(120)]],
      mes: ['', Validators.required],
      anio: ['', Validators.required],
      prestacion: ['', [Validators.required, Validators.maxLength(200)]],
      puntoVenta: ['', [Validators.required, Validators.pattern('^[0-9]{1,5}$')]],
      numeroFactura: ['', [Validators.required, Validators.pattern('^[0-9]{1,8}$')]],
      obraSocial: ['', Validators.required],
      adjComprobante: ['', [CustomFileValidator.minContentSize(this.minSize), FileValidator.maxContentSize(this.maxSize), this.pdfDocValidator]],
      adjPlanilla: ['', [FileValidator.maxContentSize(this.maxSize), this.inputPlanillaDeAsistencia]]
    });
  }

  // Validadores copiados de carga-factura
  pdfDocValidator(control: FormControl) {
    if (!control.value)
        return null;
    const type = control.value.files[0].type;
    if (type && type != 'application/pdf') {
        return {
            mimeType: {
                type: type
            }
        }
    }
    return null;
  }

  inputPlanillaDeAsistencia(control: FormControl) {
    if (!control.value)
        return null;
    const type = control.value.files[0].type;
    if (type &&
        type != 'image/png' &&
        type != 'image/jpeg' &&
        type != 'application/pdf' &&
        type != 'application/msword' &&
        type != 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
        return {
            mimeType: {
                type: type
            }
        }
    }
    return null;
  }

  // Función copiada de carga-factura para solo permitir números
  keyPressNumbers(event) {
    let charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  // Función para autocompletar punto de venta con ceros
  puntoVentaAddCharacter() {
    let valor = this.formularioConsultasFacturacion.get('puntoVenta')?.value;
    
    if(isNaN(valor) || valor == 0){
        valor = '';
        this.formularioConsultasFacturacion.controls['puntoVenta'].setValue(valor);
    }

    switch(valor?.length){
        case 1:
            valor = '0000' + valor;
            this.formularioConsultasFacturacion.controls['puntoVenta'].setValue(valor);
            break;
        case 2:
            valor = '000' + valor;
            this.formularioConsultasFacturacion.controls['puntoVenta'].setValue(valor);
            break;
        case 3:
            valor = '00' + valor;
            this.formularioConsultasFacturacion.controls['puntoVenta'].setValue(valor);
            break;
        case 4:
            valor = '0' + valor;
            this.formularioConsultasFacturacion.controls['puntoVenta'].setValue(valor);
            break;
        case 5:
            break;
        default:
            break;
    }
  }

  // Función para autocompletar número de factura con ceros
  numeroFacturaAddCharacter() {
    let valor = this.formularioConsultasFacturacion.get('numeroFactura')?.value;

    if(isNaN(valor) || valor == 0){
        valor = '';
        this.formularioConsultasFacturacion.controls['numeroFactura'].setValue(valor);
    }

    switch(valor?.length){
        case 1:
            valor = '0000000' + valor;
            this.formularioConsultasFacturacion.controls['numeroFactura'].setValue(valor);
            break;
        case 2:
            valor = '000000' + valor;
            this.formularioConsultasFacturacion.controls['numeroFactura'].setValue(valor);
            break;
        case 3:
            valor = '00000' + valor;
            this.formularioConsultasFacturacion.controls['numeroFactura'].setValue(valor);
            break;
        case 4:
            valor = '0000' + valor;
            this.formularioConsultasFacturacion.controls['numeroFactura'].setValue(valor);
            break;
        case 5:
            valor = '000' + valor;
            this.formularioConsultasFacturacion.controls['numeroFactura'].setValue(valor);
            break;
        case 6:
            valor = '00' + valor;
            this.formularioConsultasFacturacion.controls['numeroFactura'].setValue(valor);
            break;
        case 7:
            valor = '0' + valor;
            this.formularioConsultasFacturacion.controls['numeroFactura'].setValue(valor);
            break;
        case 8:
            break;
        default:
            break;
    }
  }

  reminder() {
    // Función copiada de carga-factura para recordatorio de archivos
  }

  linkPanel() {   
    window.location.href = environment.urlWebSitePhp + 'site/inicio';
  }

  onSubmit() {
    this.formularioConsultasFacturacion.markAllAsTouched();
    
    if (this.formularioConsultasFacturacion.valid) {
      const formData = new FormData();
      const formValues = this.formularioConsultasFacturacion.value;
      
      // Agregar todos los campos del formulario
      Object.keys(formValues).forEach(key => {
        if (formValues[key] && formValues[key].files) {
          // Para archivos
          formData.append(key, formValues[key].files[0]);
        } else if (formValues[key] !== null && formValues[key] !== '') {
          // Para otros campos
          formData.append(key, formValues[key]);
        }
      });
      
      // Agregar datos de sesión
      formData.append('sessionId', this.sessionId);
      formData.append('cuit', this.cuit);
      formData.append('razonSocial', this.apellidoNombreProveedor);
      
      //console.log('Consulta de facturación enviada:', formData);
      
      this._otrasGestionesProveedorService.sendFormConsultaFacturacion(formData).subscribe(
        resp => {
            //console.log('Consulta de facturación enviada:', resp);
            
            // Obtener el número de incidente de la respuesta
            let numIncidente = resp['body'] || resp['incidente'] || resp['numero']; 

            if(resp['body'] == 'Error_80') {
              this._snackBar.open('Hemos detectado que el reclamo para esta factura ya se encuentra en proceso. Su caso está siendo gestionado.', 'Cerrar', {
                duration: undefined,
                horizontalPosition: 'center',
                verticalPosition: 'top',
              });
            } else {
              this._snackBar.openFromComponent(MensajesHtmlComponent, {
                duration: undefined,
                horizontalPosition: 'center',
                verticalPosition: 'top',
                data: ['consultaProveedor', numIncidente]
              });
              
              this.formularioConsultasFacturacion.reset();
            }
            
          },
          
          err => {
            
            
            this._snackBar.open('Ha ocurrido un error: ' + (err['message'] || 'Error desconocido'), 'Cerrar', {
              duration: undefined,
              horizontalPosition: 'center',
              verticalPosition: 'top',
            });
          }
        );
    } else {
        
        this._snackBar.open('Recordá que debes completar todos los campos correctamente', 'Cerrar', {
          duration: undefined,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
    }
    
  }

  goBack() {
    this.router.navigate(['/proveedores/otras-gestiones']);
  }

  getObrasSociales(sessionID) {
    this._cargaFactura.getObrasSocialesProveedor(sessionID, true).subscribe((response: any) => {
        this.obrasSociales = response?.data.map(obra => ({ value: obra.codigo, text: obra.razon_social }));
    });
}
}
